
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import React, { useState, useEffect, useRef } from 'react';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import Toast from '../../Shared/Toast/Toast';
import { FloatLabel } from 'primereact/floatlabel';
import { useCatchResponse } from '../../../utils/useCatchResponse';

const AddLeaveReasonMasterDialog = (props) => {
    const { catchResponse } = useCatchResponse();
    const [leaveReasonName, setLeaveReasonName] = useState('');
    const [securityUserID, setSecurityUserID] = useState("");
    const [leaveReasonNameErrText, setLeaveReasonNameErrText] = useState('');
    const [leaveReasonNameErr, setLeaveReasonNameErr] = useState(false);

    const submitButtonRef = useRef(null);
    const leaveReasonNameRef = useRef(null);
    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);

        // Ensure focus after modal renders
        setTimeout(() => {
            leaveReasonNameRef.current?.focus();
        }, 100);
    }, []);

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        if (props.ID) {
            setLeaveReasonName(props?.masterData?.LeaveReasonName);
        }
    }, []);

    const onCancel = () => {
        props.onCancel();
        setLeaveReasonName('');
    }

    const validate = () => {
        let formIsValid = true;
        if (CommonConfig.isEmpty(leaveReasonName)) {
            formIsValid = false;
            setLeaveReasonNameErr(true);
            setLeaveReasonNameErrText("LeaveReason Name is required");
        } else {
            setLeaveReasonNameErr(false);
            setLeaveReasonNameErrText("");
        }
        return formIsValid;
    };

    const AddLeaveReasonMaster = async (e) => {
        if (validate(e)) {
            try {
                Loader.show();
                let data = {
                    id: props.ID,
                    LeaveReasonName: leaveReasonName.trim().replace(/\s+/g, ' '),
                    CreatedBy: securityUserID,
                };
                await api
                    .post(APIConstant.path.AddUpdateLeaveReasonMaster, data).then((response) => {
                        let res = response;
                        if (res.success) {
                            Toast.success({ message: res.message });
                            Loader.hide();
                            onCancel();
                        } else {
                            Toast.error({ message: res.message });
                            Loader.hide();
                            // onCancel();
                        }
                    })
                    .catch((err) => {
                        Toast.error({ message: err?.data?.message });
                        Loader.hide();
                        onCancel();
                    });
            } catch (err) {
                console.log(err);
                Loader.hide();
                onCancel();
                catchResponse(err);
            }
        }
    };

    const handleChange = (e, type) => {
        const value = e.target.value;
        const alphanumericValue = value.replace(/[^a-zA-Z0-9\u0A80-\u0AFF\u0900-\u097F\s]/g, '');
        setLeaveReasonName(value);
    };

    return (
        <div className="p-d-flex p-flex-column p-jc-between">
            <div className='p-grid'>
                <div className="p-col-12 p-md-12 p-pt-2">
                    <div className="custom-inputs">
                        <label className='' htmlFor="leaveReasonName">Reason Name<span style={{ color: "red" }}>*</span></label>
                        <FloatLabel>
                            <InputText
                                ref={leaveReasonNameRef}
                                className="p-mt-2 p-w-100"
                                id="leaveReasonName"
                                type="text"
                                maxLength={200}
                                placeholder="LeaveReason Name"
                                value={leaveReasonName}
                                // autoFocus={true}
                                onChange={(e) => handleChange(e)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Tab' && !e.shiftKey) {
                                        e.preventDefault();
                                        if (submitButtonRef.current) {
                                            submitButtonRef.current.focus();
                                        }
                                    }
                                }}
                            />
                        </FloatLabel>
                        <span className="error-msg" style={{ color: 'red' }}>
                            {leaveReasonNameErr ? leaveReasonNameErrText : null}
                        </span>
                    </div>
                </div>
            </div>
            <div className='dialog-footer p-d-flex p-ai-center p-jc-end'>
                <Button className='p-m-0 btn-text-action-secondary p-m-1' onClick={(e) => onCancel()}> Cancel </Button>
                <Button ref={submitButtonRef} className='p-m-0 btn-text-action-primary submit-focus' label="Submit" severity="secondary" raised onClick={(e) => AddLeaveReasonMaster()} />
            </div>
        </div>
    );
};

export default AddLeaveReasonMasterDialog;
